import React from "react";
import { Box, Typography } from "@mui/material";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
const AutocompleteOption = ({ option, inputValue }) => {
  const { classes: styles, cx } = useAutocompleteClasses();
  const optionLabel = option?.label;
  const optionSubLabel = option?.subLabel;
  const isExactMatch = typeof option === "string" ? inputValue === option : inputValue === optionLabel;
  if (option?.isSuggested) {
    return /* @__PURE__ */ React.createElement(Box, { className: styles.autocompleteOptionSuggestedItem }, optionLabel);
  }
  return /* @__PURE__ */ React.createElement(Box, { className: cx(styles.autocompleteOptionItem, { [styles.autocompleteSelected]: isExactMatch }) }, typeof option === "string" ? /* @__PURE__ */ React.createElement(Box, null, option) : /* @__PURE__ */ React.createElement(Box, { className: styles.autocompleteOptionContent }, option.startIcon ?? null, /* @__PURE__ */ React.createElement(Box, { className: styles.autocompleteOptionLabel }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, optionLabel), optionSubLabel ? /* @__PURE__ */ React.createElement(Typography, { variant: "body1", color: "textSecondary" }, optionSubLabel) : null)));
};
const renderOption = (props, option, inputValue) => {
  return /* @__PURE__ */ React.createElement("li", { ...props }, /* @__PURE__ */ React.createElement(AutocompleteOption, { option, inputValue }));
};
export {
  AutocompleteOption,
  renderOption
};
//# sourceMappingURL=AutocompleteOption.js.map
